import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6kpudxeffr: FaireBrandEntity = {
  token: "b_6kpudxeffr",
  type: "brand",
  name: "Beverly Hills Teddy Bear Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/63a3e5bd35bbc3dd9d537d8b1aac1f9f1d8f8a1818209752657c381f184c53ae.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/21c614ebebd40ea62657567603256f924fcd25379fdbdc6cbc6b94b67313bbd5.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/63a3e5bd35bbc3dd9d537d8b1aac1f9f1d8f8a1818209752657c381f184c53ae.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/21c614ebebd40ea62657567603256f924fcd25379fdbdc6cbc6b94b67313bbd5.jpeg",
  location: "Sylmar, CA, USA",
  minimumOrderDollars: 200,
  rating: 4.9,
  reviewCount: 89,
  isTopShop: true,
  isInsider: true,
  description:
    'At Beverly Hills Teddy Bear Company, we’ve been making plush toys that brought smiles for over three decades. We’re a family-owned, third generation business that blends the timeless charm of classic designs with the excitement of the latest trends. Our mission is simple: to create toys that delight children and collectors alike, all while staying true to the craftsmanship that has been at the heart of our work since day one. "We make \'em like they used to!"',
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:58.081Z",
    importedBy: "entity-db-cli",
  },
};
